/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Alert, Avatar,  Button,  Checkbox,  LinearProgress, Pagination, Paper, Snackbar, SnackbarCloseReason, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { LayoutBaseDeFolha, } from '../../../shared/layouts';
import { Environment } from '../../../shared/environment';
import { FolhaService, ITipoPgtoCheque } from '../../../shared/services/api/rh/folha/FolhaService';
import { FerramentasDaListagemFolhaCheque } from '../../../shared/components';
import ImprTipoPagamentoCheque from './ImprTipoPagamentoCheque';
import PDFCheques from './ImprmirCheque';
import { DialogCheque } from './DialogCheque';
import { ContasPagarService } from '../../../shared/services/api/Financeiro/ContasPagar';


interface ICheque {
  nome: string;     
  idfazenda: string;
  valor: number;
}
     
export const ListagemFolhaCheque: React.FC = () => {       
  const { id = '' } = useParams<'id'>();
  const { ano = '' } = useParams<'ano'>();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();  
  const [rows, setRows] = useState<ITipoPgtoCheque[]>([]);   
  const [dadosch, setDadosch] = useState<ICheque[]>();
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [fazenda, setFazenda] = useState('');          
  const [nomefazenda, setNomeFazenda] = useState('');
  const [opench, setOpench] = useState(false);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  

  const [openConfirm, setOpenConfirm] = useState(false);
            
            
  const handleDelete = () => {
    setOpenConfirm(true); 
  };
      
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') { 
      return;
    }        
    setOpenmsg(false);   
  };

  const handleConfirmDelete = () => {
    const filteredList = rows.filter((item) => item.marcado === true);
    const soma = filteredList.reduce((acc, listItem) => acc + listItem.total, 0);
    const data = { datalan: new Date(), idfazenda: fazenda, numerodoc: `${id}/${ano}`, valor: soma};
    ContasPagarService
      .BaixaFolha(data)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setOpenConfirm(false);
          setTms('success');
          setMsg('Baixa efetuada com sucesso!');
          setOpenmsg(true);
        }
      });
  };
          
  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };
                 
  const pagina = useMemo(() => {   
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  const handleFazenda = (uuid: string, nome: string) => {
    setIsLoading(true);  
    setFazenda(uuid);
    setNomeFazenda(nome);
    FolhaService.TipoPagamentoCheque(1, uuid, `${id}/${ano}`)
      .then((result) => {
        setIsLoading(false);  
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else { 
          setTotalCount(result.totalCount);
          setRows(result.data);
        }
      });          
  };         
 
  const handleGeraCheque = () => {
    const filteredList = rows.filter((item) => item.marcado === true);
   
    const listch = filteredList.map((listItem) => {
      return {
        nome: listItem.nome,
        idfazenda: fazenda,
        valor: listItem.total,
      };           
    });
    if(listch.length > 0){
      setDadosch(listch);
      setOpench(true);
    }
  };

  const handleBaixar = () => {
    setOpenConfirm(true); 
  };
  
  const handleClosech = () => {
    setOpench(false);
  };  

  const handleImprimirFolha = () => {
    ImprTipoPagamentoCheque(rows, `${id}/${ano}`, nomefazenda);
  };
                          
  const handleImprimirCheque = () => {
    const filteredList = rows.filter((item) => item.marcado === true);
    PDFCheques(filteredList);  
  };     
              
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = event.target;
    const index = rows.findIndex(row => row.idfolha === id);
    if (index === -1) return; 
    const updatedRow = { ...rows[index], marcado: checked };
    const updatedRows = [...rows.slice(0, index), updatedRow, ...rows.slice(index + 1)];
    setRows(updatedRows);
  };       
                 
  return (                             
    <LayoutBaseDeFolha
      titulo='Folha de Pagamento por Cheque'     
      barraDeFerramentas={      
        <FerramentasDaListagemFolhaCheque
          aoClicarEmImprimirFolha={handleImprimirFolha}
          aoClicarEmImprimirCheque={handleImprimirCheque}
          aoMudarTextoDoFazenda={handleFazenda}
          aoClicarEmGeraCheque={handleGeraCheque}
          aoClicarEmBaixa={handleBaixar}
        />     
      }              
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        > 
          {msg}
        </Alert>
      </Snackbar>
      <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert
          severity="warning"  
          variant="filled"
          sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
          action={
            <>
              <Button color="inherit" size="small" onClick={handleConfirmDelete}>
                    Sim
              </Button>
              <Button color="inherit" size="small" onClick={handleCancelDelete}>
                    Nâo
              </Button>
            </>
          }
        >
          Deseja realmente confirmar a baixa deste pagamento?
        </Alert>
      </Snackbar>
      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto',  marginLeft: 3,  marginRight: 2 }}>
        <Table>
          <Table size="small">   
            <TableHead>
              <TableRow>
                <TableCell  sx={{ maxWidth: 10, width:10 }} size="small" aria-label="a dense table"></TableCell>
                <TableCell>Colaborador</TableCell>
                <TableCell>CPF</TableCell>
                <TableCell align='right' sx={{ maxWidth: 100, width:100 }}>Valor</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(row => (
                <TableRow key={row.idfolha}    
                  hover
                  sx={{ cursor: 'pointer' }}  
                >
                  <TableCell><Avatar alt="F" src={Environment.URL_IMGFUNCIONARIO+row.urlimg}/></TableCell>
                  <TableCell>{row.nome}</TableCell>
                  <TableCell>{row.cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')}</TableCell>
                  <TableCell align='right'>{row.total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>
                  <TableCell> 
                    <Checkbox
                      checked={row.marcado} id={row.idfolha} onChange={handleChange}
                    />
                  </TableCell>       
                </TableRow>   
              ))}
            </TableBody>  
   
            {totalCount === 0 && !isLoading && (
              <caption>{Environment.LISTAGEM_VAZIA}</caption>
            )}
            {/* <TableFooter>
              {isLoading && (
                <TableRow>
                  <TableCell colSpan={3}>
                    <LinearProgress variant='indeterminate' />
                  </TableCell>
                </TableRow>
              )}
              {(totalCount > 0 && totalCount > Environment.LIMITE_DE_LINHASSMALL) && (
                <TableRow>
                  <TableCell colSpan={3}>
                    <Pagination  
                      page={pagina}
                      count={Math.ceil(totalCount / Environment.LIMITE_DE_LINHASSMALL)}
                      onChange={(_, newPage) => setSearchParams({ fazenda, pagina: newPage.toString() }, { replace: true })}
                    />
                  </TableCell>
                </TableRow>
              )}
            </TableFooter> */}
          </Table>
        </Table>
      </TableContainer>
      <DialogCheque
        id={''}
        dados={dadosch}
        value={''}
        open={opench} 
        onClose={handleClosech}
      /> 
    </LayoutBaseDeFolha>
  ); 
};